export enum RoutesApp {
  SignIn = 'sign-in',
  Dashboard = 'inbox',
  AddRequestProcedure17 = 'procedure17/request/add',
  ValidationRequestProcedure17 = 'procedure17/request/validation/:request_id'
}
